'use strict'

import ElementPropertiesManager from 'assets/core/js/module/elementPropertiesManager'
import HashManager from 'assets/core/js/module/hashManager'
import PartialsManager, { PartialsEvents } from 'assets/core/js/module/partialsManager'
import { Facets } from 'assets/core/js/page/product/search/facets'
import { setFiltersFromHash } from 'assets/core/js/page/product/search/filters'
import { getCapacity } from 'assets/core/js/page/product/search/utils/capacity'
import { getNights } from 'assets/core/js/page/product/search/utils/night'
import { AccommodationsData, AccommodationsOrder } from 'assets/core/js/types/globals'

import type { Calendar as SearchCalendarType } from '@ui/Search/Calendar/component'

export default function (facets: Facets): void {
  const resultsEl = document.querySelector('[data-partial-id="results"]')

  if (resultsEl) {
    resultsEl.addEventListener(PartialsEvents.POST_UPDATE, (e: Event) => {
      void (async () => {
        const detail = (e as CustomEvent).detail as {
          data: {
            accommodationsData: AccommodationsData
            accommodationsOrder: AccommodationsOrder
          }
        }

        if (detail && detail.data) {
          window.accommodationsData = detail.data.accommodationsData
          window.accommodationsOrder = detail.data.accommodationsOrder
        }
        await setFiltersFromHash(facets)
      })()
    })
  }
}

export const updatePartials = function (): void {
  const calendar = ElementPropertiesManager.getProperty<SearchCalendarType>(document.getElementById('checkInDate') as HTMLInputElement, 'calendar')
  const queryParameters: Record<string, string> = {
    night: getNights(),
    capacity: getCapacity(),
    checkInDate: calendar?.input.value as string,
  }

  const hashParameters = { ...HashManager.getParameters(), ...queryParameters }

  if (queryParameters.checkInDate === '') {
    delete queryParameters.checkInDate
    delete hashParameters.checkInDate
  }

  if (queryParameters.night === '') {
    delete queryParameters.night
    delete hashParameters.night
  }

  PartialsManager.update('product', queryParameters)
  HashManager.setParameters(hashParameters, true)
}
